import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65c21880"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "font-normal text-xl" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "ml-10" }
const _hoisted_4 = { class: "flex flex-row ml-10" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-filter" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_7 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-medium" }, "%", -1))
const _hoisted_9 = {
  class: "relative",
  style: {"min-height":"100px"}
}
const _hoisted_10 = {
  key: 1,
  class: "mt-2 bg-white rounded p-5 text-center"
}
const _hoisted_11 = { class: "font-size-big font-normal" }
const _hoisted_12 = { class: "collective-gross-margin-modal" }
const _hoisted_13 = { class: "collective-gross-margin-modal__caution" }
const _hoisted_14 = { class: "collective-gross-margin-modal__field" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " This operation will change all margins in the tab. Are You sure? ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Switch = _resolveComponent("Switch")!
  const _component_proposal_products_add = _resolveComponent("proposal-products-add")!
  const _component_proposal_products_remove = _resolveComponent("proposal-products-remove")!
  const _component_outline_button = _resolveComponent("outline-button")!
  const _component_layout_wrapper = _resolveComponent("layout-wrapper")!
  const _component_content_loader = _resolveComponent("content-loader")!
  const _component_sale_prices_table = _resolveComponent("sale-prices-table")!
  const _component_sale_prices_form_filters_modal = _resolveComponent("sale-prices-form-filters-modal")!
  const _component_percent_input = _resolveComponent("percent-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_layout_wrapper, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('proposal.outbound.header.title')), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(_component_Switch, {
              id: "gross-margin",
              modelValue: _ctx.grossMargin,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.grossMargin) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('proposal.general.gross_margin')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Switch, {
              id: "cost-prices",
              modelValue: _ctx.costPrice,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.costPrice) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('proposal.general.cost_prices')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.isProposalEditable && !_ctx.isSurcharges)
              ? (_openBlock(), _createBlock(_component_proposal_products_add, { key: 0 }))
              : _createCommentVNode("", true),
            (_ctx.isProposalEditable && !_ctx.isSurcharges)
              ? (_openBlock(), _createBlock(_component_proposal_products_remove, {
                  key: 1,
                  class: "ml-2"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_outline_button, {
              class: "ml-2",
              type: "outline",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFilters = true))
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createTextVNode("  " + _toDisplayString(_ctx.$t('general.filter')), 1)
              ]),
              _: 1
            })
          ]),
          (_ctx.isProposalEditable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_outline_button, {
                  type: "outline",
                  small: true,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleSelectClick(true)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('proposal.general.select_all')), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.isProposalEditable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_outline_button, {
                  type: "outline",
                  small: true,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleSelectClick(false)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('proposal.general.select_none')), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.isProposalEditable)
            ? (_openBlock(), _createBlock(_component_outline_button, {
                key: 2,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showCollectiveGrossMarginModal = true)),
                class: "ml-2"
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createTextVNode(" GM ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isProposalEditable)
            ? _renderSlot(_ctx.$slots, "extra-actions", { key: 3 }, undefined, true)
            : _createCommentVNode("", true)
        ])
      ]),
      _: 3
    }),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.isProposalLoading)
        ? (_openBlock(), _createBlock(_component_content_loader, {
            key: 0,
            label: "general.loading"
          }))
        : _createCommentVNode("", true),
      (!!_ctx.salePricesRows && !_ctx.salePricesRows.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, " There are no prices. Try to choose Suppliers. "))
        : _createCommentVNode("", true),
      (!!_ctx.salePricesRows && _ctx.salePricesRows.length)
        ? (_openBlock(), _createBlock(_component_sale_prices_table, {
            key: 2,
            isSurcharges: _ctx.isSurcharges,
            "weight-brackets": _ctx.weightBracketsFiltered,
            "sale-prices-rows": _ctx.rowsFiltered,
            "sort-column": _ctx.sortColumn,
            onRowDeleteClick: _ctx.handleRowDeleteClick,
            onChangeSort: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleChangeSort($event)))
          }, null, 8, ["isSurcharges", "weight-brackets", "sale-prices-rows", "sort-column", "onRowDeleteClick"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.filters)
      ? (_openBlock(), _createBlock(_component_sale_prices_form_filters_modal, {
          key: 0,
          "show-filters": _ctx.showFilters,
          "onUpdate:showFilters": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showFilters) = $event)),
          filters: _ctx.filters,
          onFiltersChange: _ctx.handleFiltersChange
        }, null, 8, ["show-filters", "filters", "onFiltersChange"]))
      : _createCommentVNode("", true),
    _createVNode(_component_modal, {
      modelValue: _ctx.showCollectiveGrossMarginModal,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showCollectiveGrossMarginModal) = $event)),
      onConfirmClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showChangeGrossMarginConfirm = true))
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('proposal.collective.title')), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('proposal.collective.caution')), 1),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('proposal.starting.gross_value')), 1),
            _createVNode(_component_percent_input, {
              class: "ml-3 bg-white",
              modelValue: _ctx.collectiveGrossMargin,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.collectiveGrossMargin) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_modal, {
      type: "warning",
      modelValue: _ctx.showChangeGrossMarginConfirm,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showChangeGrossMarginConfirm) = $event)),
      onConfirmClick: _ctx.handleWarningGrossMarginConfirmClick
    }, {
      title: _withCtx(() => [
        _createTextVNode("Warning")
      ]),
      default: _withCtx(() => [
        _hoisted_15
      ]),
      _: 1
    }, 8, ["modelValue", "onConfirmClick"])
  ], 64))
}